module.exports = __webpack_public_path__ + "img/Small-Horizontal-Rectangular-Attachment-47.400c44b7.png";